'use strict';



const $ = require('jquery');
const debounce = require('debounce');
const overlayGutter = 160;
const debouncedOffsetMap = debounce(offsetMap, 500);
let initialised = false;
let $map;
let $overlay;
let coords;
let latLng;
let maps;
let map;



/**
 * Contact Map
 */
window.contactMap = () => {

	$(() => {

		$map = $('.js-contact-map');
		$overlay = $('.js-contact-map-overlay');

		if($map.length === 0) {
			return;
		}

		coords = $map.data('coords')
			.split(',')
			.map(parseFloat);

		latLng = { lat: coords[0], lng: coords[1] };
		maps = window.google.maps;

		map = new maps.Map($map[0], {
			center: latLng,
			zoom: 9,
			disableDefaultUI: true,
			draggable: false,
			disableDoubleClickZoom: true,
			scrollwheel: false
		});

		new maps.Marker({
			position: latLng,
			map
		});

		$(window).on('resize', debouncedOffsetMap);

		map.addListener('tilesloaded', () => {
			if(initialised) {
				return;
			}
			initialised = true;
			offsetMap();
		});

	});

};



/**
 * Offset Map
 *
 * Offsets the map by the width of the overlay.
 */
function offsetMap() {
	map.setCenter(latLng);
	const offset = ( $overlay.width() / 2 ) + overlayGutter;
	map.panBy(offset * -1, 0);
}